module.exports = __webpack_public_path__ + "img/HK_Logo.eff587a6.png";